export enum ValidationState {
  EMPTY_INITIAL_STATE = 'EMPTY_INITIAL_STATE',
  QUERY_PARAM_INVALID = 'query-param-invalid',
  QUERY_PARAM_USER_INPUT_INVALID = 'query-param-user-input-invalid', // only for invalid user input after an invalid query params
  QUERY_PARAM_VALID = 'query-param-valid',
  USER_INPUT_INVALID = 'user-input-invalid',
  USER_INPUT_VALID = 'user-input-valid',
}
